var map = {
	"./angular-js.jpg": "Szhw",
	"./bootstrap4.png": "ijkH",
	"./ms-sql.jpg": "mThk",
	"./net-core.png": "bm/W",
	"./net.jpg": "MZu/",
	"./vue-js.jpg": "WleD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KuVB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology ^\.\/.*$
// module id = KuVB
// module chunks = 0